/**
 * Query keys for the address search (search plan docs/plans/2026-10-30-feat-explorer-address-search-plan.md,
 * D4). The root is never persisted: query-persistence.ts skips it.
 */
export const openAddressSearchKeys = {
  all: ['open-address-search'] as const,
  release: () => [...openAddressSearchKeys.all, 'release'] as const,
};
